// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Badge } from '../../Badge';
import { Icon } from '../../Icon';
import { Label } from '../../Label';
export var TabStructure = function (_a) {
    var badgeText = _a.badgeText, children = _a.children, icon = _a.icon, _b = _a.iconOnly, iconOnly = _b === void 0 ? false : _b, selected = _a.selected, onClick = _a.onClick, className = _a.className;
    return (React.createElement(Container, { className: className, role: 'tab', "aria-selected": selected, tabIndex: 1, onClick: onClick, "aria-label": children },
        icon && React.createElement(Icon, { ariaLabel: "tab-icon-" + icon, name: icon }),
        iconOnly ? null : (React.createElement(Label, { size: 'small', styleVariant: selected ? 'bold' : 'regular', title: children }, children)),
        !iconOnly && badgeText && (React.createElement(Badge, { size: 'small', shape: 'square', styleVariant: 'subtle' }, badgeText))));
};
//# sourceMappingURL=TabStructure.js.map